<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="ah-upsert-dialog outsourcing-person-upsert-dialog"
        append-to-body
        top="5vh"
        :before-close="() => onClose()"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">
            <div>{{ sno ? "編輯" : "新增" }}委外勞務</div>
        </template>
        <div class="dialog-body">
            <el-form :model="form" ref="form" label-position="top" label-width="150px" v-loading="isLoading" size="small">
                <div class="dialog-layout">
                    <div class="info-block">
                        <div class="section-title">
                            <div>基本資料</div>
                        </div>
                        <el-form-item prop="caT_SNO" label="委外類型" :rules="rules.caT_SNO">
                            <OutsourcingTypeSelect v-model="form.caT_SNO" type="person" />
                        </el-form-item>
                        <el-form-item prop="fnam" label="姓名" :rules="rules.fnam">
                            <el-input v-model="form.fnam" style="max-width: 480px" :maxlength="50" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item prop="abd" label="國籍">
                            <el-radio v-model="form.abd" :label="0" @change="onAbdChanged">本國人</el-radio>
                            <el-radio v-model="form.abd" :label="1" @change="onAbdChanged">外國籍 (在台已滿183天)</el-radio>
                            <el-radio v-model="form.abd" :label="2" @change="onAbdChanged">外國籍 (在台未滿183天)</el-radio>
                        </el-form-item>
                        <el-row :gutter="20">
                            <el-col :sm="12">
                                <el-form-item v-if="form.abd !== 0" prop="identificationType" label="證件類型">
                                    <el-radio v-model="form.identificationType" :label="1" @change="onBsnTypChange">護照號碼</el-radio>
                                    <el-radio v-model="form.identificationType" :label="2" @change="onBsnTypChange">居留證</el-radio>
                                </el-form-item>
                                <el-form-item v-if="form.abd === 0" prop="bsN_TYP" label="證件類型">
                                    <el-radio v-model="form.bsN_TYP" :label="1" @change="onBsnTypChange">身分證</el-radio>
                                    <el-radio v-model="form.bsN_TYP" :label="2" @change="onBsnTypChange">營業統一編號</el-radio>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12">
                                <el-form-item prop="bsn" :label="bsnLabelName" :rules="bsnRule" required key="bsn-form-item">
                                    <el-input v-model.trim="form.bsn" :maxlength="20" :show-word-limit="true" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :sm="12">
                                <el-form-item v-if="form.vendorContacts" prop="vendorContacts[0].tel" label="聯絡電話" :rules="isServiceFeeMode ? rules.vendorContactsTel : null">
                                    <el-input v-model="form.vendorContacts[0].tel" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12">
                                <el-form-item v-if="form.vendorContacts" prop="vendorContactsEml" label="E-mail">
                                    <el-input v-model="form.vendorContacts[0].eml" :maxlength="100" :show-word-limit="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item prop="permanentAddr" label="戶籍地址" key="permanent-addr-form-item" :rules="isServiceFeeMode ? rules.permanentAddr : null">
                            <div v-if="form.abd === 0" style="display: flex; flex-direction: column; gap: 5px;" >
                                <div style="display: flex; gap: 5px;">
                                    <el-input v-model="form.permanentAdR_CODE" style="width: 90px; flex-shrink: 0;" placeholder="郵遞區號" :maxlength="6"></el-input>
                                    <TwCountySelect v-model="form.permanentAddrCty" key="county" style="width: 120px; flex-shrink: 0;" />
                                    <el-input v-model="form.permanentAddr" :maxlength="50" :show-word-limit="true"></el-input>
                                </div>
                            </div>
                            <div v-if="form.abd === 1 || form.abd === 2" style="display: flex; flex-direction: column; gap: 5px;">
                                <div style="display: flex; gap: 5px;">
                                    <el-input v-model="form.permanentAdR_CODE" style="width: 120px" placeholder="郵遞區號" :maxlength="6"></el-input>
                                    <CountrySelect v-model="form.permanentAddrAra" key="country-select" />
                                </div>
                                <el-input v-model="form.permanentAddr" :maxlength="50" :show-word-limit="true"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="adr" label="聯絡地址" key="addr-form-item" :rules="isServiceFeeMode ? rules.adr : null">
                            <template v-slot:label>
                                <span>聯絡地址</span>
                                <el-button style="margin-left: 12px;" size="mini" @click="onSameAddr" round class="tiny-button">同上</el-button>
                            </template>
                            <div v-if="form.abd === 0" style="display: flex; flex-direction: column; gap: 5px;">
                                <div style="display: flex; gap: 5px;">
                                    <el-input v-model="form.adR_CODE" style="width: 90px; flex-shrink: 0;" placeholder="郵遞區號" :maxlength="6"></el-input>
                                    <TwCountySelect v-model="form.cty" key="county" style="width: 120px; flex-shrink: 0;" />
                                    <el-input v-model="form.adr" :maxlength="50" :show-word-limit="true"></el-input>
                                </div>
                            </div>
                            <div v-if="form.abd === 1 || form.abd === 2" style="display: flex; flex-direction: column; gap: 5px;">
                                <div style="display: flex; gap: 5px;">
                                    <el-input v-model="form.adR_CODE" style="width: 120px" placeholder="郵遞區號" :maxlength="6"></el-input>
                                    <CountrySelect v-model="form.ara" key="country-select" />
                                </div>
                                <div style="display: flex; gap: 5px;">
                                    <el-input v-model="form.adr" :maxlength="50" :show-word-limit="true"></el-input>
                                    <el-button size="mini" @click="onSameAddr">同上</el-button>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="note" label="備註">
                            <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="" v-model="form.note" :maxlength="200" :show-word-limit="true"> </el-input>
                        </el-form-item>
                        <!-- <el-form-item prop="adR_CODE" label="郵遞區號">
                            <ah-number-input v-model="form.adR_CODE" style="display: block; width: 150px" :maxlength="6" :placeholder="form.abd == 0 ? '' : 'ZIP code'"></ah-number-input>
                        </el-form-item> -->
                    </div>
                    <div class="bank-block">
                        <div class="section-title">證件</div>
                        <el-form-item prop="idCardFront" label="證件正反面" label-position="top">
                            <div class="document-section">
                                <div class="document-block">
                                    <el-image
                                            v-if="form.idCardFront"
                                        :src="form.idCardFront"
                                        :previewSrcList="[form.idCardFront]"
                                        class="idcard-image"
                                        fit="contain"
                                    ></el-image>
                                    <ahUploader
                                        :value="form.idCardFront"
                                        ref="ahUploader"
                                        head-shot
                                        accept="image/png, image/jpeg"
                                        @change="($event) => onChangeAttachment($event, 'idCardFront')"
                                        :watermark="`僅供 ${companyName} 請款使用`"
                                    ></ahUploader>
                                </div>
                                <div class="document-block">
                                    <el-image
                                        v-if="form.idCardBack"
                                        :src="form.idCardBack"
                                        :previewSrcList="[form.idCardBack]"
                                        class="idcard-image"
                                        fit="contain"
                                    ></el-image>
                                    <ahUploader
                                        :value="form.idCardBack"
                                        ref="ahUploader"
                                        head-shot
                                        accept="image/png, image/jpeg"
                                        :watermark="`僅供 ${companyName} 請款使用`"
                                        @change="($event) => onChangeAttachment($event, 'idCardBack')"
                                    />
                                </div>
                            </div>
                        </el-form-item>
                        <el-row :gutter="20">
                            <el-col :sm="8">
                                <el-form-item prop="oS_GRP">
                                    <template slot="label">投保職業工會<ahTip>有投保職業工會，免扣二代健保。</ahTip> </template>
                                    <el-radio v-model="form.oS_GRP" :label="true">有</el-radio>
                                    <el-radio v-model="form.oS_GRP" :label="false">無</el-radio>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="16">
                                <el-form-item v-if="form.oS_GRP" prop="unionInsuranceExpireDate" label="投保工會有效日期">
                                    <el-date-picker v-model="form.unionInsuranceExpireDate" type="date" value-format="timestamp" placeholder="選擇日期"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item v-if="form.oS_GRP" prop="unionInsuranceDoc" label="投保工會證明文件">
                            <div class="document-section">
                                <div>
                                    <div v-if="form.unionInsuranceDoc" class="document-block">
                                        <el-image
                                            :src="form.unionInsuranceDoc"
                                            :previewSrcList="[form.unionInsuranceDoc]"
                                            style="width: 150px; height: 150px; border: 1px solid #ddd; border-radius: 5px;"
                                            it="contain"
                                        ></el-image>
                                    </div>
                                    <ahUploader
                                        :value="form.unionInsuranceDoc"
                                        ref="ahUploader"
                                        head-shot
                                        accept="image/png, image/jpeg"
                                        :watermark="`僅供 ${companyName} 請款使用`"
                                        @change="($event) => onChangeAttachment($event, 'unionInsuranceDoc')"
                                    />
                                </div>
                            </div>
                        </el-form-item>
                        <div class="section-title" style="margin-top: 20px;">收款帳戶</div>
                        <el-form-item prop="vendorBanks">
                            <bank-account-card
                                v-for="(bank, index) in form.vendorBanks"
                                v-show="!bank.deleted"
                                :key="bank.sno"
                                :data="bank"
                                @edit="onBankAccountEdit(bank, index)"
                                @delete="onBankAccountDelete(bank, index)"
                            />
                            <el-button size="small" icon="el-icon-plus" @click="onAddBankAccount">新增帳戶</el-button>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <div class="dialog-footer">
            <el-button type="normal" @click="onClose()" icon="el-icon-close" :loading="isLoading">取消{{ sno ? "編輯" : "新增" }}</el-button>
            <el-button type="primary" class="primary-action" @click="onSubmit" icon="el-icon-check" :loading="isLoading">{{ sno ? "儲存" : "新增" }}</el-button>
        </div>
        <bank-account-upsert-dialog
            key="bank-account-upsert-dialog"
            :visible="bankUpsertDialog.visible"
            :data="bankUpsertDialog.data"
            :fnam="form.fnam"
            @submit="onBankAccountUpsertDialogSubmit"
            @close="onBankAccountUpsertDialogClose"
        />
    </el-dialog>
</template>
<script>
import { isGuiNumberValid, isNationalIdentificationNumberValid } from 'taiwan-id-validator';
import CountrySelect from '@/components/ui/CountrySelect.vue';
import TwCountySelect from '@/components/ui/TwCountySelect.vue';
import OutsourcingTypeSelect from '@/components/ui/OutsourcingTypeSelect.vue';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';
import BankAccountCard from '../BankAccountCard.vue';
import BankAccountUpsertDialog from '../BankAccountUpsertDialog.vue';

export default {
    name: 'outsourcing-person-upsert-dialog',
    components: {
        CountrySelect,
        TwCountySelect,
        OutsourcingTypeSelect,
        BankAccountCard,
        BankAccountUpsertDialog,
        ahUploader,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: Number,
            default: null,
        },
        isServiceFeeMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const validateBsnComp = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else if (!isGuiNumberValid(value, true)) {
                callback(new Error('統一編號格式不正確'));
            } else {
                callback();
            }
        };

        const validateBsnId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入身分證號碼。'));
            } else if (!isNationalIdentificationNumberValid(value)) {
                callback(new Error('身分證號碼格式不正確'));
            } else {
                callback();
            }
        };

        return {
            isLoading: false,
            // 資料表單
            form: {
                sno: null,
                onf: 1, // 啟用
                vdR_TYP: 'OS', // VD=廠商,OS=個人
                caT_SNO: null, // 委外類型
                cnam: null, // 簡稱（廠商簡稱）
                fnam: null, // 全名（個人姓名/廠商公司全名）
                abd: 0, // 0=國內,1=境外
                abD_TYP: null, // 境外身份：0政府/1公營事業/2民間
                bsn: null, // 證件號碼 / 統編
                bsN_NO: 0, // 1=無統編,0=有統編
                bilL_DAY: '1', // 結帳日
                soO_DAY: '1', // 收款日
                identificationType: 1, // 證件類型（外國籍）
                bsN_TYP: 1, // 證件類型（本國）： 1= 個人身分證 2=營業統一編號
                idCardFront: null, // 身分證正面
                idCardBack: null, // 身分證背面
                oS_GRP: false, //  有無職業工會
                unionInsuranceDoc: null, // 職業工會投保證明文件
                unionInsuranceExpireDate: null, // 職業工會投保有效日期
                note: null, // 備註
                permanentAddr: null, // 戶籍地址
                permanentAddrCty: null, // 戶籍地址-縣市
                permanentAddrAra: null, // 戶籍地址-地區（外國籍）
                permanentAdR_CODE: null, // 戶籍地址-郵遞區號
                adr: null, // 聯絡地址
                cty: null, // 聯絡地址-城市
                ara: null, // 聯絡地址-地區（外國籍）
                adR_CODE: null, // 聯絡地址-郵遞區號
                contactAddrAra: null, // contactAddrAra
                vendorContacts: [
                    {
                        key: Date.now(),
                        nam: '',
                        gen: 0,
                        job: '',
                        tel: '',
                        ext: '',
                        eml: '',
                        dep: '',
                    },
                ], // 聯絡資訊
                vendorBanks: [], // 匯款帳戶
            },
            // 表單驗證
            rules: {
                fnam: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
                bsn_id: [{ required: true, validator: validateBsnId, trigger: 'blur' }],
                bsn_comp: [{ required: true, validator: validateBsnComp, trigger: 'blur' }],
                oS_TYP: [
                    {
                        required: true,
                        message: '請選擇類型',
                        trigger: 'change',
                    },
                ],
                caT_SNO: [
                    {
                        required: true,
                        message: '請選擇類型',
                        trigger: 'change',
                    },
                ],
                // 勞報單必填規則
                vendorContactsTel: [{ required: true, message: '請輸入聯絡電話', trigger: 'blur' }],
                permanentAddr: [{ required: true, message: '請輸入戶籍地址', trigger: 'blur' }],
                adr: [{ required: true, message: '請輸入聯絡地址', trigger: 'blur' }],
            },
            // 銀行帳戶編輯視窗
            bankUpsertDialog: {
                visible: false,
                data: null,
                index: null,
            },
        };
    },
    computed: {
        bsnLabelName() {
            if (this.form.abd === 0) {
                if (this.form.bsN_TYP === 1) return '身分證號碼';
                if (this.form.bsN_TYP === 2) return '營業統一編號';
            }
            if (this.form.abd !== 0) {
                if (this.form.identificationType === 1) return '護照號碼';
                if (this.form.identificationType === 2) return '居留證';
            }
            return '---';
        },
        bsnRule() {
            if (this.form.abd === 0) {
                if (this.form.bsN_TYP === 1) return this.rules.bsn_id;
                if (this.form.bsN_TYP === 2) return this.rules.bsn_comp;
            }
            return [{ required: true, message: `請輸入${this.bsnLabelName}` }];
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },
    methods: {
        // 載入資料
        async fetchData(sno) {
            if (!sno) return;
            this.isLoading = true;

            try {
                const resp = await this.$api({
                    url: `Outsourcing/GetOutsourcingInfo?sno=${sno}`,
                    method: 'GET',
                });

                if (resp.data.item) {
                    this.form = resp.data.item;
                    if (this.form.vendorContacts.length <= 0) {
                        this.form.vendorContacts = [
                            {
                                key: Date.now(),
                                nam: '',
                                gen: 0,
                                job: '',
                                tel: '',
                                ext: '',
                                eml: '',
                                dep: '',
                            },
                        ];
                    }
                }
            } finally {
                this.isLoading = false;
            }
        },

        // 開啟視窗
        onOpen() {
            this.fetchData(this.sno);
        },

        // 關閉視窗
        onClose(refresh) {
            this.form = {
                sno: null,
                onf: 1, // 啟用
                vdR_TYP: 'OS', // VD=廠商,OS=個人
                caT_SNO: null, // 委外類型
                cnam: null, // 簡稱（廠商簡稱）
                fnam: null, // 全名（個人姓名/廠商公司全名）
                abd: 0, // 0=國內,1=境外
                abD_TYP: null, // 境外身份：0政府/1公營事業/2民間
                bsn: null, // 證件號碼 / 統編
                bsN_NO: 0, // 1=無統編,0=有統編
                bilL_DAY: '1', // 結帳日
                soO_DAY: '1', // 收款日
                identificationType: 1, // 證件類型（外國籍）
                bsN_TYP: 1, // 證件類型（本國）： 1= 個人身分證 2=營業統一編號
                idCardFront: null, // 身分證正面
                idCardBack: null, // 身分證背面
                oS_GRP: false, //  有無職業工會
                unionInsuranceDoc: null, // 職業工會投保證明文件
                unionInsuranceExpireDate: null, // 職業工會投保有效日期
                note: null, // 備註
                permanentAddr: null, // 戶籍地址
                permanentAddrCty: null, // 戶籍地址-縣市
                permanentAddrAra: null, // 戶籍地址-地區（外國籍）
                permanentAdR_CODE: null, // 戶籍地址-郵遞區號
                adr: null, // 聯絡地址
                cty: null, // 聯絡地址-城市
                ara: null, // 聯絡地址-地區（外國籍）
                adR_CODE: null, // 聯絡地址-郵遞區號
                contactAddrAra: null, // contactAddrAra
                vendorContacts: [
                    {
                        key: Date.now(),
                        nam: '',
                        gen: 0,
                        job: '',
                        tel: '',
                        ext: '',
                        eml: '',
                        dep: '',
                    },
                ], // 聯絡資訊
                vendorBanks: [], // 匯款帳戶
            };
            this.$emit('close', refresh);
        },

        // 聯絡地址同上（戶籍地址）
        onSameAddr() {
            this.form.cty = this.form.permanentAddrCty;
            this.form.adr = this.form.permanentAddr;
            this.form.ara = this.form.permanentAddrAra;
            this.form.adR_CODE = this.form.permanentAdR_CODE;
        },

        // 送出
        onSubmit() {
            try {
                this.$refs.form.validate(async (valid) => {
                    if (!valid) return;

                    // 未新增帳戶時，自動塞入一筆空白帳戶
                    // if (!this.form.vendorBanks.filter((o) => !o.deleted).length) {
                    //     this.form.vendorBanks.push({
                    //         sno: null,
                    //         accountType: 1,
                    //         bnK_BOO: null,
                    //         bnK_DOO: null,
                    //         bnK_TPC: null,
                    //         bnK_ACC: null,
                    //         swiftCode: null,
                    //         passbookDoc: null,
                    //         filE_AGREE: null,
                    //         note: null,
                    //     });
                    // }

                    // 境內 資料刪除
                    if (this.form.abd === 0) {
                        this.form.abD_TYP = null;
                        this.form.ara = null;
                        this.form.permanentAddrAra = null;
                        this.form.identificationType = 0;
                    }

                    // 境外 資料刪除
                    if (this.form.abd !== 0) {
                        this.form.bsN_TYP = 0;
                        this.form.cty = null;
                        this.form.permanentAddrCty = null;
                    }

                    // 無投保工會，刪除投保證明
                    if (!this.form.oS_GRP) {
                        this.form.unionInsuranceDoc = null;
                        this.form.unionInsuranceExpireDate = null;
                    }

                    this.form.vendorBanks.forEach((item) => {
                        if (item.accountType === 1) {
                            // eslint-disable-next-line no-param-reassign
                            item.abroadBankName = null;
                            // eslint-disable-next-line no-param-reassign
                            item.swiftCode = null;
                        } else if (item.accountType === 2) {
                            // eslint-disable-next-line no-param-reassign
                            item.bnK_BOO = null;
                            // eslint-disable-next-line no-param-reassign
                            item.bnK_DOO = null;
                        }
                    });

                    this.isLoading = true;

                    console.log('form', this.form);

                    const resp = await this.$api({
                        url: 'Outsourcing/UpsertOutsourcingDetail',
                        method: 'POST',
                        data: this.form,
                    });

                    console.log('resp', resp);

                    this.$emit('submit', resp.data.sno);
                    this.onClose(true);
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        // 變更國籍
        onAbdChanged() {
            // 本國人
            if (this.form.abd === 0) {
                this.form.abD_TYP = null;
                this.form.ara = null;
                this.form.permanentAddrAra = null;
                if (!this.form.bsN_TYP) this.form.bsN_TYP = 1;
            }

            // 外國人（境外）
            if (this.form.abd !== 0) {
                this.form.abD_TYP = 2;
            }
            this.onResetFormValidation();
        },

        // 變更證件類型
        onBsnTypChange() {
            this.onResetFormValidation();
        },

        // 新增銀行帳戶
        onAddBankAccount() {
            this.bankUpsertDialog.data = {
                sno: null,
                accountType: 1,
                bnK_BOO: null,
                bnK_DOO: null,
                bnK_TPC: this.form.fnam,
                bnK_ACC: null,
                swiftCode: null,
                passbookDoc: null,
                note: null,
                filE_AGREE: null,
            };
            this.bankUpsertDialog.index = null;
            this.bankUpsertDialog.visible = true;
        },
        // 編輯銀行帳戶
        onBankAccountEdit(bankAccount, index) {
            this.bankUpsertDialog.data = { ...bankAccount };
            this.bankUpsertDialog.index = index;
            this.bankUpsertDialog.visible = true;
        },
        // 刪除銀行帳戶
        onBankAccountDelete(bankAccount, index) {
            if (bankAccount.sno) {
                this.form.vendorBanks[index].deleted = true;
            } else {
                this.form.vendorBanks.splice(index, 1);
            }
        },
        // 編輯銀行帳戶視窗-送出
        onBankAccountUpsertDialogSubmit(bank) {
            // 編輯
            if (this.bankUpsertDialog.index !== null) this.form.vendorBanks[this.bankUpsertDialog.index] = { ...bank };
            // 新增
            else this.form.vendorBanks.push({ ...bank, deleted: false });

            this.bankUpsertDialog.visible = false;
            this.bankUpsertDialog.data = null;
            this.bankUpsertDialog.index = null;
        },
        // 編輯銀行帳戶視窗-關閉
        onBankAccountUpsertDialogClose() {
            this.bankUpsertDialog.visible = false;
        },

        onResetFormValidation() {
            this.$refs.form.clearValidate();
        },
        onChangeAttachment(val, fieldName) {
            this.form[fieldName] = val.filE_ATT;
        },
    },
};
</script>

<style lang="scss">
.outsourcing-person-upsert-dialog {
    .el-dialog {
        width: 98%;
        padding: 0;
        border-radius: 18px;

        @media (min-width: 1240px) {
            width: 1200px;
        }

        .el-dialog__body {
            padding: 0;
        }
    }
    .dialog-body {
        margin-top: 30px;
        padding: 30px;
    }
    .dialog-footer {
        display: flex;
        justify-content: end;
        background-color: #f6f6f6;
        padding: 20px 30px;
        border-bottom-left-radius: 18px;
        border-bottom-right-radius: 18px;
    }

    .dialog-layout {
        display: grid;
        grid-template-columns: 1fr;
        gap: 70px;
        padding: 0 20px;

        @media (min-width: 1200px) {
            grid-template-columns: 1fr 1fr;
        }
    }

    .el-form-item__label {
        font-weight: bold;
    }
    .el-input__inner {
        // background-color: #f6f6f6;
        border-radius: 8px;
    }
    .document-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;

        .document-block {
            display: flex;
            flex-direction: column;
        }

        .idcard-image {
            width: 100%;
            aspect-ratio: 1.5;
            border: 1px solid #eee;
        }
    }

    .section-title {
        position: relative;
        border-bottom: 1px solid #ccc;
        padding: 5px 0;
        margin-bottom: 20px;

        >div {
            display: inline-block;
            padding-right: 10px;
            position: relative;
            background-color: #fff;
            z-index: 1;
        }

        // &::after {
        //     display: block;
        //     position: absolute;
        //     top: 50%;
        //     content: '';
        //     width: 100%;
        //     border-top: 1px solid #ccc;
        // }
    }
    // .el-form-item__label {
    //     padding-right: 30px;
    // }
    // .section-title {
    //     padding: 10px 0;
    //     font-size: 10.5pt;
    //     font-weight: bold;
    //     border-bottom: 1px solid #eee;
    //     margin-bottom: 40px;
    //     margin-top: 40px;
    //     // background-color: #eee;
    // }

    .tiny-button {
        padding: 3px 10px;
    }
}
</style>
